import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Collaborator } from "@models/collaborator";
import { Page } from "@models/page";
import { CollaboratorRoleEnumPipe } from "@shared/pipes/collaborator-role-enum.pipe";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";

@Component({
  selector: "app-employees-table",
  imports: [
    TableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    SkeletonModule,
    PaginatorModule,
    CollaboratorRoleEnumPipe,
  ],
  templateUrl: "./employees-table.component.html",
  styleUrl: "./employees-table.component.scss",
})
export class EmployeesTableComponent {
  @Input() data: Page<Collaborator> | null = null;
  @Input() readOnly = false;
  first = 0;
  rows = 10;

  @Output() removeEmployeeClick = new EventEmitter<Collaborator>();
  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() editPdvPermission = new EventEmitter<Collaborator>();
}
